<template>
  <div>
    <div class="container" id="take">
      <h2 class="text-center header-font">Program Structure</h2>
      <p class="first-p">
        UI & UX bootcamp consists of 20 hours of materials delivered over 4
        weeks. To participate in this Bootcamp, you are required to pass an
        assessment test with minimum 60% of the total score.
        <br />
        <br />
        The bootcamp will only have 25 seats. It’s on a first come first served
        basis. Take the quiz today to secure your spot.
      </p>
      <div class="grid">
        <div class="text">
          <h4>Length</h4>
          <h3 class="bongo_dark_red">
            4 weeks
          </h3>
        </div>
        <div class="text">
          <h4>Bootcamp Starts</h4>
          <h3 class="bongo_dark_red">5th Dec, <br />2021</h3>
        </div>
        <div class="text">
          <h4>Cost</h4>
          <h3 class="bongo_dark_red">BDT <br />8000**</h3>
        </div>
        <div class="text">
          <h4>Quiz Deadline</h4>
          <h3 class="bongo_dark_red">
            2nd Dec,
            <br />

            2021
          </h3>
        </div>
        <div class="text">
          <h4>Course Outline</h4>
          <a
            class="btn"
            href="https://upskill-files.s3.ap-southeast-1.amazonaws.com/UX++UI+Bongo+bootcamp/Upskill+__+UI+%26+UX+Design+Bootcamp.pdf"
            target="_blank"
          >
            Download PDF
          </a>
        </div>
      </div>
      <div class="grid-2 bongo_dark_red_bg">
        <p style="text-align:left;color:white">
          ** If you take the quiz by 27th November and qualify for the interview
          , you’ll avail a 20% discount course fee and have to pay BDT 6400.
          <br />
          <br />
          Top 5 participants will get a chance to interview at bongo for the
          position of Junior UI/UX designer. So, don’t miss the offer as the
          seats are limited!
        </p>
        <!--
        <a
          href="https://quiz.upskill.com.bd/assessment/e5482c3e-5c92-45ff-b375-dc63884f223c?public=true"
        >
          <button class="btn-1">
            Take the Quiz
          </button>
        </a> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.btn {
  background-color: transparent;
  border: 1px solid #2465f3;
  color: #2465f3;
  padding: 7px 30px;
  cursor: pointer;
  font-size: 16px;
}

/* Darker background on mouse-over */
.btn:hover {
  background-color: transparent;
}
.btn-1 {
  background-color: white;
  min-width: 240px;
  min-height: 50px;
  border: none;
  color: #2465f3;
  padding: 7px 30px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 4px;
}

/* Darker background on mouse-over */
.btn-1:hover {
  background-color: #f8f8ff;
}
.grid-2 {
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  padding: 50px 150px;
}
.grid-2 p {
  padding-left: 25px;
  font: 700 1.125rem/1.5rem 'Manrope';
  color: white;
  max-width: 600px !important;
}
.container p {
  text-align: center;
  max-width: 1020px;
  margin: 0 auto;
  font: 400 1.125rem/1.4rem 'Manrope';
  color: #626367;
}
.first-p {
  text-align: center;
  max-width: 970px;
  margin: 0 auto;
  font: 400 1.125rem/1.4rem 'Manrope';
  color: #626367;
  padding-bottom: 50px;
}
.text h4 {
  font: 700 1.5rem/1.75rem 'Manrope';
  color: #29292b;
}
.text h3 {
  font: 700 2.25rem/2.75rem 'Manrope';
}
.header-font {
  padding-top: 100px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b;
  padding-bottom: 50px;
}
.grid {
  padding: 50px;
  background-color: white;
  margin: 0 auto;
  max-width: 1300px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
@media only screen and (max-width: 600px) {
  .grid {
    padding: 50px;
    background-color: white;
    margin: 0 auto;
    max-width: 350px;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 25px;
  }
  .grid-2 {
    display: flex;
    flex-direction: column;
    padding: 20px 15px;
  }
  .text h4 {
    font: 700 1.25rem/1.75rem 'Manrope';
  }
  .text h3 {
    font: 700 1.75rem/2.5rem 'Manrope';
  }
  .grid-2 p {
    padding-left: 0;
    padding-bottom: 25px;
  }
  .grid-2 a {
    display: flex;
    justify-content: center;
  }
}
</style>
